// extracted by mini-css-extract-plugin
export default {"item":"item___TJw5E","key":"key___VRp0r"};